import { render, staticRenderFns } from "./BioDesign.vue?vue&type=template&id=6e126b25&scoped=true&"
import script from "./BioDesign.vue?vue&type=script&lang=js&"
export * from "./BioDesign.vue?vue&type=script&lang=js&"
import style0 from "./BioDesign.vue?vue&type=style&index=0&id=6e126b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e126b25",
  null
  
)

export default component.exports